import useEventListener from '@use-it/event-listener';
import type { FC } from 'react';
import { useStore } from '../store';

export const KeyPressManager: FC = () => {
  const toggleTimer = useStore((state) => state.actions.toggleTimer);

  function handleKeyPress(event: Event) {
    const focusEl = window.document.activeElement;

    if (
      (focusEl == null ||
        !['input', 'textarea', 'button'].includes(focusEl.tagName.toLowerCase())) &&
      (event as KeyboardEvent).key === ' '
    ) {
      event.preventDefault();
      toggleTimer();
    }
  }

  useEventListener('keypress', handleKeyPress, window, { capture: true });

  return null;
};
